<template>
        <div >
            <transition-group name="fade" mode="out-in" tag="div" class="posts__section posts__section--tickets" v-show="!isFetching">

                <div v-cloak :key="product.id" class="post__content" v-for="(product, index) in products" v-show="!isFetching">

                    <div class="product-item-container">

                        <a v-if="product.images.length > 1">
                            <slick
                                    class="post__content-thumbnail"
                                    ref="slick"
                                    :options="{ arrows: true, dots: true, infinite: false }"
                            >
                                <div v-for="image in product.images" class="slider-inner" ><img :src="'https://amsterdamlightfestival.com/storage/' + image" alt=""></div>
                            </slick><!-- /.post__content-thumbnail -->
                        </a>
                        <a v-else class="no-slider">
                            <slick
                                    class="post__content-thumbnail"
                                    ref="slick"
                                    :options="{ arrows: true, dots: true, infinite: false }"
                            >
                                <div v-for="image in product.images" class="slider-inner" ><img :src="'https://amsterdamlightfestival.com/storage/' + image" alt=""></div>
                            </slick><!-- /.post__content-thumbnail -->
                        </a>

                        <div x-data="{showPriceOverlay: false}" class="post__content-inner">
                            <div class="content-stretch">
                              <h2>{{product.title}}</h2>

                              <div class="product-content" v-html="product.content"></div>

                              <!-- v-show="product.start_date" -->
                              <!-- {{ product.start_date }} - {{ product.end_date }} -->
                              <div v-if="product.overlay_text" x-show="showPriceOverlay" class="product-content-prices-list">
                                <button type="button" class="product-content-prices-list-close" x-on:click="showPriceOverlay = false"><i class="far fa-times"></i></button>
                                <div v-html="product.overlay_text">
                                </div>
                              </div>
                            </div>

                            <p v-if="product.duration_label" class="date-duration"><i class="far fa-clock"></i>{{ product.duration_label }}</p>

                            <div class="characteristics">
                                <div class="characteristic" v-for="(characteristic, index) in product.characteristics">
                                    <img class="characteristic-icon" :src="'/site/img/characteristic-' + characteristic.type + '.svg'"/>
                                    <span class="characteristic-text"><span>{{ characteristic.name }}</span></span>
                                </div>
                            </div>

                            <span v-show="product.highlighted">{{highlighted}}</span>
                            <div class="post__content-action">
                                <div class="post__content-price-indication" v-if="product.from_label">
                                    <span>
                                        {{ product.from_label }}
                                    </span>
                                    <span>
                                        <span v-if="product.price_label">€</span>{{ product.price_label }}
                                    </span>
                                </div>
                                <div v-if="product.overlay_text" style="margin-left:auto">
                                    <button type="button" class="post__content-price-toggle" x-on:click="showPriceOverlay = !showPriceOverlay">
                                        {{ product.overlay_button_text }}
                                    </button>
                                </div>
                            </div><!-- /.action-section -->
                            <div class="post__content-action">
                                <!-- <a v-if="product.cta_style === 'primair'" :href="'/product/' + product.id + '?locale=' + helpers.getLocale()" :data-href="product.cta_url" :target="product.external_link ? '_blank' : '_self'" rel="noopener noreferrer" class="post__content-btn product post__content-btn-primair" @click="registerGoogleClick(product)">
                                      {{ product.cta_label }}
                                      <bhf-product-button-gradient/>
                                  </a> -->
                                <a v-if="product.cta_url" :href="'/product/' + product.id + '?locale=' + helpers.getLocale()" :data-href="product.cta_url" :target="product.external_link ? '_blank' : '_self'" class="post__content-btn product " :class="{pink: product.pink_button}" rel="noopener noreferrer" @click="registerGoogleClick(product)">
                                  {{ product.cta_label }}
                                </a>
                            </div>
                        </div>
                    </div>

                </div><!-- /.posts__section -->

            </transition-group>

            <transition name="fade" mode="out-in">
                <alf-loader v-show="isFetching"></alf-loader>
            </transition>

        </div>
</template>


<script>
    import Loader from '.././loader'
    import helpers from '../../helpers';
    import BhfSpecialFilterSlides from './bhf-special-filter-slide.vue'
    import ProductButtonGradient from './product-button-gradient.vue'
    import Slick from 'vue-slick'
    export default{
        components: {
            Slick,
            'alf-loader': Loader,
            'bhf-special-filter-slides': BhfSpecialFilterSlides,
            'bhf-product-button-gradient': ProductButtonGradient
        },
        props: {
            'products': {required: true},
            'isFetching': {required: true},
            // 'specialFilterSlug': {required: true},
            // 'activeSpecialFilter': {required: true},
        },
        data: function(){
            return {
                helpers: helpers,
                showPrices: false,
            }
        },

        methods: {

            reInit: function() {

                // Helpful if you have to deal with v-for to update dynamic lists
                this.$nextTick(() => {

                    if(this.$refs.slick === undefined){
                        return;
                    }

                    let sliders = this.$refs.slick;
                    for(let i = 0; i < sliders.length; i++){
                        sliders[i].reSlick();
                    }
                });
            },
            registerGoogleClick: function(product){
                ga('send', 'pageview', '/outbound/' + helpers.getLocale() + '/' + product.product_category_title + '/' + helpers.slugify(product.title) + '/' + product.id);
            },
            hrefTarget (slide) {
                return (slide.target_blank ? "_blank" : "_self")
            },
            slideButtonText: function(slide){
                if(slide.button_text){
                    return slide.button_text;
                }

                if(helpers.getLocale() === 'nl'){
                    return "MEER INFO"
                }

                return "MORE INFO";
            },
        },
        computed: {
            // showSponsorSlider: function(){
            //     if(this.isFetching)
            //        return false;

            //     if(!this.activeSpecialFilter.slides)
            //         return false;

            //     return this.activeSpecialFilter.slides.length > 0;
            // },
            highlighted: function() {
                if(helpers.getLocale() === 'nl') {
                    return 'UITGELICHT';
                }
                return 'FEATURED';
            },
        }
    }
</script>


<style lang="scss" scoped>

    .post__content-inner {
        padding-top: 0;
    }

    .post__content-inner h2 {
        font-size: 22px;
        padding-top: 20px;
        margin: 0 0 -4px;
        letter-spacing: 0.01em;
        hyphens: auto;
    }

    .post__content-action{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        flex-wrap: wrap;
        margin-top: 12px;

        &:before{
            display: none;
        }
    }

    .post__content-action .post__content-btn {
        width: 100%;
        float: none;
        padding: 11px 13px 10px 13px !important;
        text-align: center;
        font-size: 18px;
        line-height: 20px;
        margin-top: 16px;
    }

    .post__content-price-toggle {
        appearance: none;
        padding: 0;
        margin: 0;
        background: none;
        border: 0;
        box-shadow: none;
        color: #777777;
        text-decoration: underline;
        cursor: pointer;
    }

    .post__content-price-indication {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap:8px;
        flex: 1 1 auto;
        height: 60px;
        margin-top: 10px;
        padding-right: 0.5em;

        span:first-of-type {
            font-style: normal;
            font-size: 14px;
            line-height: 16px;
            color: #606060;
            text-transform: uppercase;
        }
        span:last-of-type {
            font-style: normal;
            font-size: 30px;
            line-height: 33px;
            color: #000000;
            text-transform: uppercase;
            letter-spacing: -0.3px;
        }
    }

    .content-stretch {
        position: relative;
        flex: 1 1 auto;
    }

</style>

<style lang="scss">

    .posts__section--tickets .post__content {
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      height: auto;
      margin-bottom: 0;
      padding-bottom: 40px;
    }
    .posts__section--tickets .product-item-container {
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      height: 100%;
    }
    .posts__section--tickets .product-item-container > a:first-child {
      flex: 0 0 auto;
    }
    .posts__section--tickets .product-item-container > .post__content-inner {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      height: auto;
    }
    .posts__section--tickets .product-item-container > .post__content-inner > * {
      flex: 0 0 auto;
    }
    .posts__section--tickets .product-item-container > .post__content-inner > .content-stretch {
      flex: 1 1 auto;
    }
    .product-content-prices-list {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      width: 100%;
      min-height: 100%;
      background-color: #EEEDED;
      display: flex;
      text-align: left;
      padding: 26px 12px;
      font-size: 14px !important;
      line-height: 1.4 !important;
      z-index: 1;
    }

    .product-content-prices-list > div {
      margin: auto;
    }

    .product-content-prices-list-close {
      position: absolute;
      top: 4px;
      right: 8px;
      font-size: 16px;
      color: #333333;
      appearance: none;
      padding: 0;
      margin: 0;
      background: none;
      border: 0;
      box-shadow: none;
      cursor: pointer;
    }

    .product-content-prices-list p {
      padding:0;
      margin: 0;
      text-align: left;
      font-size: 14px;
      line-height: 1.4;
    }
    .product-content-prices-list table {
      background: none;
      border: 0;
      padding:0;
      margin: 0 0 12px;
      text-align: left;
      font-size: 14px;
      line-height: 1.4;
      width: auto !important;

    }

    .product-content-prices-list table tr > td:first-of-type {
      font-weight: normal;
      text-align: left;
      font-size: 14px !important;
      line-height: 1.4;
      padding: 0 16px 0 0 !important;
      margin: 0 !important;
    }
    .product-content-prices-list table tr > td:nth-of-type(2) {
      font-weight: bold;
      text-align: left;
      font-size: 14px !important;
      line-height: 1.4;
      padding: 0 !important;
      margin: 0 !important;
      width: initial !important;
    }

    .characteristics {
        z-index: 1;
    }

    .characteristics:after {
        content: "";
        clear: both;
        display: block;
    }

    .characteristic {
        position: relative;
        height: 30px;
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 15px;
        cursor: pointer;
        z-index: 0;
        transition: z-index 0.3s cubic-bezier(1, 0, 1, 0);
    }

    .characteristic:nth-child(4) {
        justify-content: flex-end;
    }
    .characteristic:nth-child(5) {
        justify-content: flex-end;
    }

    .characteristic:hover {
        cursor: pointer;
        z-index: 3;
        transition: z-index 0s cubic-bezier(1, 0, 1, 0);
    }

    .characteristic-icon {
        position: relative;
        height: 30px;
        margin-top: -1px;
        margin-right: 8px;
        z-index: 1;
    }

    .characteristic:last-child .characteristic-icon {
        margin-right: 0;
    }

    .characteristic-text {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        max-width: 30px;
        margin-left: auto;
        border-radius: 30px;
        background-color: white;
        border: 1px solid black;
        overflow: hidden;
        z-index: 0;
        transition: max-width 0.4s cubic-bezier(.42,.38,0,1);
    }

    .characteristic:nth-child(4) .characteristic-text {
        left: auto;
        right: 0;
    }
    .characteristic:nth-child(5) .characteristic-text {
        left: auto;
        right: 0;
    }

    .characteristic-text > span {
        min-width: 105px;
        opacity: 0;
        padding: 0 12px 0 44px;
        transition: opacity 0.3s linear;
    }

    .characteristic:nth-child(4) .characteristic-text > span {
        padding: 0 30px 0 12px;
    }
    .characteristic:nth-child(5) .characteristic-text > span {
        padding: 0 30px 0 12px;
    }

    .characteristic:hover .characteristic-text {
        max-width: 300px;
        opacity: 1;
        transition: max-width 1.1s cubic-bezier(.42,.38,0,1);
    }

    .characteristic:hover .characteristic-text > span {
        opacity: 1;
        transition: opacity 0.3s linear 0.1s;
    }

    .bookatour .page_content{
        padding-top: 25px;
        padding-bottom: 0;
    }

    .product-item-container{
        position: relative;
    }

    .product-content{
        margin-bottom: 10px;
    }

    #bhf-filter .post__content .product-content ul {
        margin: 0 0 23px !important;
        padding-left: 16px !important;
        font-family: inherit !important;
    }

    .post__content{
        position: relative;
        width: 50%;
    }

    @media only screen and (max-width: 767px) {
        .post__content {
            width: 50%;
        }
    }

    .post__content-action:before {
        width: 130px;
    }

    .post__content-inner{
        .date-duration{
            display: block;
            margin: 15px 0 -10px;
            color: #333333;
            font-size: 15px;
            i{
                margin-right: 10px;
            }
        }
     }

    @media only screen and (min-width: 994px) and (max-width: 1200px) {

        .post__content {
            .product-content {
                min-height: 0;
            }

            .post__content-action:before {
                width: calc(100% - 130px)
            }
            .post__content-inner {
                .product-content {
                    h2 {
                        font-size: 22px;
                        line-height: 1.2em;
                        margin-bottom: 10px;
                    }
                }

            }
        }
    }

    @media only screen and (max-width: 600px){
        .post__content {
            width: 100%;
        }
    }

    /*.post__content-inner{*/
        /*min-height:150px;*/
    /*}*/

    .slider-inner img{
        max-width: 325px;
        max-height:225px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
    .fade-enter-active {
        @for $i from 1 through 30 {
            &:nth-of-type(#{$i}) {
                transition-delay: $i * 0.06s;
            }
        }
    }
    [v-cloak] {display: none}


    .post__content-inner h2{
        line-height: 1.2;
        margin-bottom: 5px;
    }

    @media screen and(max-width: 375px){
        .post__content{
            padding-left: 0 !important;
            padding-right: 0 !important;
        }

    }

    .post__content-btn{
        position: relative;
        text-transform: uppercase;
    }

    .post__content-btn-primair{
        padding: 2px 23px 2px 7px !important;
        color: white !important;
        border-color: transparent !important;
    }

    .post__content-btn.product svg{
        right: 7px;
        top: 6px;
    }

    .product-content{
        font-size: 15px !important;
        line-height: 20px !important;
        color: #606060;
        p{
            font-size: 15px !important;
            line-height: 20px !important;
            margin-top: 10px;
        }
    }

    .categories li.active svg {
        fill: #000;
    }
    .night .categories li.active svg {
        fill: #FFF;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/bhf-filter/bhf-filter-listing.vue